import { useSyncExternalStore } from 'react'

import { isViewPromoPending, subscribeToViewPromo } from './planningViewDefault'

export const usePlanningViewPromoPending = (partnerId: string) =>
  useSyncExternalStore(subscribeToViewPromo, () => isViewPromoPending(partnerId))
